import StandardFormControl from '../../components/utilityComponents/StandardFormControl';
import InputMapper from '../../mappers/InputMapper';
import { useQuestionLibraryActions } from '../../store/questionLibraryStore';
import type { SmartAnswer } from '../../types/smartAnswers';
import type { QuestionLibraryError } from '../../utils/errorHandling';

type SimpleInputProps = {
  inputType?: string;
  field?: any;
  name?: string;
  label?: string;
  rules?: any;
  infoToolTip?: string;
  error?: QuestionLibraryError;
  disabled?: boolean;
  smartAnswer?: SmartAnswer;
  sx?: { maxWidth?: string };
  maxWidth?: string;
};

export default function SimpleInput({
  inputType,
  field,
  error,
  disabled,
  ...question
}: Readonly<SimpleInputProps>) {
  const { setFocusedQuestion } = useQuestionLibraryActions();

  return (
    <StandardFormControl
      field={field}
      error={error}
      padding={'0, 0.25rem, 1rem, 0.25rem'}
      {...question}
      onFocus={() => setFocusedQuestion(question.name, question.smartAnswer)}
    >
      <InputMapper
        inputType={inputType}
        hasError={error.hasError}
        field={field}
        question={question}
        disabled={disabled}
        maxInputWidth={question.sx?.maxWidth ?? question.maxWidth ?? '240px'}
        aria-labelledby={`${question.name}-label`}
      />
    </StandardFormControl>
  );
}
